document.addEventListener('DOMContentLoaded', function () {  
  // Grabbing the DOM elements
  const tabsContainer = document.getElementById('category-tabs');
  const mobileSelect = document.getElementById('category-select');
  const contentContainer = document.getElementById('category-row');
  const searchInput = document.getElementById('search-input');
  const faqDataElement = document.getElementById('faq-data');
  
  let faqData = { categories: [], settings: {} };
  
  // Parse FAQ data from JSON embedded in page
  try {
    if (faqDataElement) {
      faqData = JSON.parse(faqDataElement.textContent);
    }
  } catch (error) {
    console.error('Error parsing FAQ data:', error);
  }

  const categories = faqData.categories || [];
  
  // Remove initial server-rendered content when JS takes over
  const initialContent = contentContainer.querySelector('[data-initial="true"]');
  if (initialContent && categories.length > 0) {
    // Display first category's questions via JS
    displayQuestions(categories[0].questions);
  }

  // Setup tab click events
  const tabs = tabsContainer.querySelectorAll('.category-tab');
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', function () {
      tabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      mobileSelect.value = index;
      if (categories[index]) {
        displayQuestions(categories[index].questions);
      }
    });
  });
  
  // Mobile select change event
  mobileSelect.addEventListener('change', function () {
    const index = Number(this.value);
    tabs.forEach(t => t.classList.remove('active'));
    if (tabs[index]) {
      tabs[index].classList.add('active');
    }
    if (categories[index]) {
      displayQuestions(categories[index].questions);
    }
  });
  
  // Search input event for filtering questions
  searchInput.addEventListener('input', function () {
    const query = this.value.trim().toLowerCase();
    if (!query) {
      // Return to active category
      const activeTab = document.querySelector('.category-tab.active');
      const activeIndex = activeTab ? Number(activeTab.dataset.index) : 0;
      if (categories[activeIndex]) {
        displayQuestions(categories[activeIndex].questions);
      }
      return;
    }
    
    // Search across all categories
    let allQuestions = [];
    categories.forEach(category => {
      if (category.questions) {
        allQuestions = allQuestions.concat(category.questions);
      }
    });
    
    const results = allQuestions.filter(item =>
      (item.question && item.question.toLowerCase().includes(query)) ||
      (item.answer && stripHtml(item.answer).toLowerCase().includes(query))
    );
    displayQuestions(results);
  });
  
  // Function to display questions in the UI
  function displayQuestions(questions) {
    contentContainer.innerHTML = '';
    
    if (!questions || questions.length === 0) {
      return;
    }
    
    const questionsList = document.createElement('ul');
    questionsList.className = 'help-center-articles';
    
    questions.forEach(item => {
      const li = document.createElement('li');
      li.className = 'help-center-article';
      
      const toggleContainer = document.createElement('div');
      toggleContainer.className = 'article-toggle custom-border-radius-5';
      
      const titleEl = document.createElement('h3');
      titleEl.className = 'article-title';
      titleEl.textContent = item.question || 'No question available.';
      
      const contentEl = document.createElement('div');
      contentEl.className = 'article-content';
      contentEl.innerHTML = item.answer || '<p>No answer available.</p>';
      
      titleEl.addEventListener('click', function () {
        toggleContainer.classList.toggle('active');
      });
      
      toggleContainer.appendChild(titleEl);
      toggleContainer.appendChild(contentEl);
      li.appendChild(toggleContainer);
      questionsList.appendChild(li);
    });
    
    contentContainer.appendChild(questionsList);
  }
  
  // Function to create a typing effect in the search input placeholder
  function startTypingEffect(titles) {
    if (!titles || titles.length === 0) return;
    
    let currentTitleIndex = 0;
    let currentCharIndex = 0;
    const typingSpeed = parseInt(searchInput.dataset.typingSpeed) || 100;
    const deletingSpeed = parseInt(searchInput.dataset.deletingSpeed) || 60;
    const delayAfterWordTyped = parseInt(searchInput.dataset.delayAfterWordTyped) || 2400;
    const delayBeforeFirstDelete = parseInt(searchInput.dataset.delayBeforeFirstDelete) || 2000;
    const delayAfterDeleting = parseInt(searchInput.dataset.delayAfterDeleting) || 500;
    let firstWordTyped = true;

    function type() {
      if (currentCharIndex <= titles[currentTitleIndex].length) {
        searchInput.placeholder = titles[currentTitleIndex].substring(0, currentCharIndex);
        currentCharIndex++;
        setTimeout(type, typingSpeed);
      } else {
        let delay = (firstWordTyped && currentTitleIndex === 0) ? delayBeforeFirstDelete : delayAfterWordTyped;
        firstWordTyped = false;
        setTimeout(erase, delay);
      }
    }
    
    function erase() {
      if (currentCharIndex > 0) {
        searchInput.placeholder = titles[currentTitleIndex].substring(0, currentCharIndex);
        currentCharIndex--;
        setTimeout(erase, deletingSpeed);
      } else {
        currentTitleIndex = (currentTitleIndex + 1) % titles.length;
        setTimeout(type, delayAfterDeleting);
      }
    }
    
    type();
  }

  // Helper function to strip HTML tags for search
  function stripHtml(html) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  // Start typing effect with question titles
  let titles = [];
  categories.forEach(category => {
    if (category.questions) {
      category.questions.forEach(item => {
        if (item.question) {
          titles.push(item.question);
        }
      });
    }
  });
  
  // Use only the first 5 titles for the typing effect
  if (titles.length) {
    startTypingEffect(titles.slice(0, 5));
  }
});